import { render, staticRenderFns } from "./needMap.vue?vue&type=template&id=63fb1406&scoped=true"
import script from "./needMap.vue?vue&type=script&lang=js"
export * from "./needMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb1406",
  null
  
)

export default component.exports